import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { createaccounttype, viewaccounttype } from "../../../../services/admin";
import { toast } from "react-toastify";

export default function AddAccountType() {
    const navigate = useNavigate();
    const { id } = useParams();

    const [formData, setFormData] = useState({
        id: 0,
        type_name: "",
        type_code: "",
        description: "",
        normal_balance: "Debit",
        display_order: 0,
        is_active: true,
    });

    useEffect(() => {
        if (id) {
            viewaccounttype(id).then((res) => {
                if (res.status === true) {
                    const data = res.data.details;
                    setFormData({
                        id: data.id,
                        type_name: data.type_name,
                        type_code: data.type_code,
                        description: data.description || "",
                        normal_balance: data.normal_balance,
                        display_order: data.display_order,
                        is_active: data.is_active,
                    });
                }
            });
        }
    }, [id]);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!formData.type_name) {
            toast.error("Please enter type name");
            return;
        }
        if (!formData.type_code) {
            toast.error("Please enter type code");
            return;
        }

        createaccounttype(formData).then((res) => {
            if (res.status === true) {
                toast.success(res.message);
                navigate("/master/accounttypes");
            } else {
                toast.error(res.message);
            }
        });
    };

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">
                    {id ? "Edit Account Type" : "Add Account Type"}
                </h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Master</a>
                    </li>
                    <li className="breadcrumb-item">
                        <a onClick={() => navigate("/master/accounttypes")}>Account Types</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        {id ? "Edit" : "Add"}
                    </li>
                </ol>
            </div>

            <div className="content-body">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col-6">
                                            <h4 className="card-title">
                                                {id ? "Edit Account Type" : "Add New Account Type"}
                                            </h4>
                                        </div>
                                        <div className="col-6 text-end">
                                            <button
                                                className="btn btn-secondary"
                                                onClick={() => navigate("/master/accounttypes")}
                                            >
                                                <i className="fa fa-arrow-left"></i> Back
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">
                                                    Type Name <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="type_name"
                                                    value={formData.type_name}
                                                    onChange={handleInputChange}
                                                    placeholder="Enter type name (e.g., Asset)"
                                                />
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">
                                                    Type Code <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="type_code"
                                                    value={formData.type_code}
                                                    onChange={handleInputChange}
                                                    placeholder="Enter type code (e.g., AST)"
                                                    disabled={id ? true : false}
                                                />
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">
                                                    Normal Balance <span className="text-danger">*</span>
                                                </label>
                                                <select
                                                    className="form-control"
                                                    name="normal_balance"
                                                    value={formData.normal_balance}
                                                    onChange={handleInputChange}
                                                >
                                                    <option value="Debit">Debit</option>
                                                    <option value="Credit">Credit</option>
                                                </select>
                                                <small className="text-muted">
                                                    Asset & Expense = Debit | Liability, Equity & Income = Credit
                                                </small>
                                            </div>

                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Display Order</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    name="display_order"
                                                    value={formData.display_order}
                                                    onChange={handleInputChange}
                                                    min="0"
                                                />
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-12 mb-3">
                                                <label className="form-label">Description</label>
                                                <textarea
                                                    className="form-control"
                                                    name="description"
                                                    value={formData.description}
                                                    onChange={handleInputChange}
                                                    rows="3"
                                                    placeholder="Enter description"
                                                ></textarea>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-12 mb-3">
                                                <div className="form-check">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        name="is_active"
                                                        checked={formData.is_active}
                                                        onChange={handleInputChange}
                                                        id="is_active"
                                                    />
                                                    <label className="form-check-label" htmlFor="is_active">
                                                        Active
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row mt-3">
                                            <div className="col-md-12 text-end">
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary me-2"
                                                    onClick={() => navigate("/master/accounttypes")}
                                                >
                                                    Cancel
                                                </button>
                                                <button type="submit" className="btn btn-primary">
                                                    <i className="fa fa-save"></i>{" "}
                                                    {id ? "Update" : "Create"}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
